















import { Vue, Component, Prop } from "vue-property-decorator";
import design from "../../assets/scss/_variables.scss";

/**
 * This component is used for rendering titles that match the UI design guidelines
 */
@Component({})
export default class AnxContent extends Vue {
  /**
   * This is the size of the header.
   * Note: This will also be used as tag name (e.g. h1 renders a <h1> tag in the source code)
   * @values h1, h2, h3
   */
  @Prop({ default: "h1" }) size!: string;

  /** No margin after the title */
  @Prop({ default: null }) noMargin!: boolean | null;

  /** The text, to be displayed (can also be set via slot) */
  @Prop({ default: "" }) text!: string;

  /** Do not display a line after the title */
  @Prop({ default: null }) noline!: boolean | null;

  /** The margin after the title */
  @Prop({ default: null }) margin!: string | null;

  get cssProps() {
    return {
      "--margin-bottom":
        this.margin !== null ? this.margin : design.titleSpacing
    };
  }
}
